import React, { useEffect, useState } from 'react'
import CenterModal from "../Components/CenterSelectorModal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API from '../Services/Coupon'
import moment from "moment";
import LocationList from '../Components/Location';
const CouponList = () => {
    const [selectedCenter, setSelectedCenter] = useState([]);
    const [couponList, setCouponList] = useState([])
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 10
    const [id, setId] = useState([])
    const [code, setCode] = useState("")
    const [type, setType] = useState("")
    const [description, setaDescription] = useState("")
    const [discount, setDiscount] = useState("")
    const [purchaseAmount, setPurchaseAmount] = useState("")
    const [limit, setLimit] = useState("")
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [error, setError] = useState({});
    const [center, setCenter] = useState("")
    const [status, setStatus] = useState("")
    const [count, setCount] = useState("")
    const [createdAt, setCreatedAt] = useState("");
    const [centerId, setCenterId] = useState("")
    const [updateDate, setUpdateDate] = useState("")
    const [locationId, setLocationId] = useState("")

    useEffect(() => {
        getCouponsList()
    }, [currentPage, selectedCenter])

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        switch (fieldName) {
            case "code":
                setCode(value);
                break;
            case "type":
                setType(value);
                break;
            case "center":
                setSelectedCenter(value);
                break;
            case "discount":
                setDiscount(value);
                break;
            case "purchaseAmount":
                setPurchaseAmount(value);
                break;
            case "limit":
                setLimit(value);
                break;
            case "startDate":
                setStartDate(value);
                break;
            case "endDate":
                setEndDate(value);
                break;
            case "description":
                setaDescription(value);
                break;
            case "locationId":
                setLocationId(value);
                break;
        }


    }
    const validateFields = () => {
        const errors = {};
        if (!code.trim()) errors.code = "Coupon code is required";
        if (!type) errors.type = "Type is required";
        if (!description.trim()) errors.description = "Description is required";
        if (!discount || isNaN(Number(discount))) errors.discount = "Valid discount is required";
        if (!purchaseAmount || isNaN(Number(purchaseAmount)))
            errors.purchaseAmount = "Valid purchase amount is required";
        if (!limit || isNaN(Number(limit))) errors.limit = "Valid usage limit is required";
        // if (!startDate) errors.startDate = "Start date is required";
        if (!endDate) errors.endDate = "End date is required";
        // if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
        //     errors.endDate = "End date cannot be earlier than start date";
        // }
        // if (selectedCenter.length === 0) errors.center = "Please select at least one center";
        if (!locationId) { errors.locationId = "Center is required" }
        setError(errors);
        return Object.keys(errors).length === 0;
    };
    const getCouponsList = async () => {
        try {
            const payload = {
                pageNumber: currentPage,
                location_id: selectedCenter.length > 0 ? selectedCenter.join(",") : null,
                limit: perPage
            };
            const response = await API.getCoupons(payload);
            setCouponList(response?.data?.data?.rows || []);
            setTotalRecords(response?.data?.data?.count || 0);

        } catch (error) {
            toast.dismiss();

            if (!error.response) {
                toast.error("Network error! Please check your internet connection");

            } else if (error.response.status === 403) {
                window.location.replace("/Login");

            } else if (error.response.status === 404) {
                setCouponList([]);
                setTotalRecords(0);
                toast.info("No record found");

            } else {
                toast.error(error?.response?.data?.message || "Something went wrong");
            }
        }
    };

    const totalPages = Math.ceil(totalRecords / perPage);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            // getDiscountList();
        }
    };
    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, '...');
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push('...', totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    };


    const handleGetData = async (couponId) => {
        // console.log("id.......", couponId)
        const paylaod = {
            pageNumber: 1,
            limit: perPage,
            id: couponId
        }
        try {
            const response = await API.getCoupons(paylaod);
            const fetchedData = response?.data?.data?.rows?.[0];
           // console.log(fetchedData, 'fetchedData');
            if (fetchedData) {
                //setHighlight(true);
                setId(fetchedData.id);
                setCode(fetchedData?.code)
                setType(fetchedData?.type)
                setaDescription(fetchedData?.description)
                setDiscount(fetchedData?.discount)
                setPurchaseAmount(fetchedData?.min_purchase_amount)
                setLimit(fetchedData?.usage_limit)
                setStartDate(fetchedData?.start_date)
                setEndDate(fetchedData?.end_date)
                setCenter(fetchedData?.location_name)
                setStatus(fetchedData?.is_active)
                setCount(fetchedData?.used_count)
                setCreatedAt(fetchedData?.createdAt)
                // setCenterId(fetchedData?.location_id)
                // setSelectedCenter(fetchedData.location_id);
                // setUpdateDate(fetchedData?.updatedAt)
                // setLocationId(fetchedData?.Location?.name);
                setLocationId(fetchedData?.location_id);


            } else {
                toast.error("Failed to coupon details.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    };

    const updateCouponList = async () => {

        try {
            const payload = {
                id: id,
                code: code,
                description: description,
                type: type,
                discount: discount,
                min_purchase_amount: purchaseAmount,
                usage_limit: limit,
                used_count: count,
                // start_date: startDate,
                end_date: endDate,
                //is_active: status,
                // createdAt: createdAt,
                // updatedAt: updateDate,
                location_id: locationId,

                // Location: center,
            };
            //console.log("update..", payload)
            const response = await API.updateCouponData(id, payload);
          //  console.log("update data...", response?.data)
            if (response?.status === 200) {
                toast.success(response?.data?.message);
                getCouponsList()
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Failed to update Coupon Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error updating discount :", error);
            toast.error("An unexpected error occurred. Please try again later.");
        }
    }





    const handleUpdateData = async () => {
        if (!validateFields()) return;
        await updateCouponList();
    };


    const handleSelectedCenter = (selectedData) => {
        //console.log("selected data......", selectedData)
        setSelectedCenter(selectedData);
        setCurrentPage(1);
    };

    const handleError = (error) => {
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };


    const changeStatus = async (id, currentStatus) => {
        const updatedStatus = !currentStatus;
        try {
            const response = await API.CouponStatus(id, updatedStatus);
            console.log("response.......", response)
            if (response.status === 200) {
                setCouponList((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(
                    `Coupon  ${updatedStatus ? "Activated" : "De-Activated"} successfully!`
                );
                getCouponsList();
            } else {
                console.log("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.log("Error in status toggle:", error);
            handleError(error);
        }
    };



    const handleCancel = () => {
        window.location.reload();
        setSelectedCenter([''])
        setCode('')
        setType('')
        setaDescription('')
        setDiscount('')
        setPurchaseAmount('')
        setLimit('')
        setStartDate('')
        setEndDate('')
    }





    return (
        <div>

            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Added Coupon</h4>
                    </div>
                    <div className="card-body">
                        {/* {error && <div className="alert alert-danger">{error}</div>} */}
                        <div className="row mb-3">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <CenterModal onSelectCenter={handleSelectedCenter}
                                    />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <button onClick={() => {
                                    setCurrentPage(1);
                                    getCouponsList();
                                }} className="btn btn-success mt-4" type="button" >Search</button>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>SrNo</th>
                                        <th>Action</th>
                                        <th>Code</th>
                                        <th>Type</th>
                                        <th>Center</th>
                                        <th>Discount</th>
                                        <th>Status</th>
                                        <th>Min purchase amount</th>
                                        <th>Limit</th>
                                        <th>Count</th>
                                        <th>Expiry Date</th>
                                        <th>created-Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {couponList.map((item, index) => (
                                        // console.log(".........",item),
                                        <tr key={item.id} data-active={item?.is_active ? "true" : "false"}>
                                            <td>{(currentPage - 1) * perPage + index + 1}</td>
                                            <td>
                                                <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                    <ul className="navbar-nav navbar-nav-right">
                                                        <li className="nav-item nav-profile1">
                                                            <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <div className="nav-profile-text1">
                                                                    <p className="mb-1 text-black">
                                                                    </p>
                                                                </div>
                                                            </span>
                                                            <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                            <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalViewDiscount">
                                                                        View
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    <button
                                                                        onClick={() => handleGetData(item.id)}
                                                                        className="btn btn-primary btn-sm" type="button"
                                                                        data-bs-toggle="modal" data-bs-target="#myModal"
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">

                                                                    <button
                                                                        className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                        onClick={() => changeStatus(item.id, item.is_active)}
                                                                    >
                                                                        {item.is_active ? "De-Activate" : "Activate"}
                                                                    </button>
                                                                </a>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                            <td>{item.code}</td>
                                            <td>
                                                {item.type}
                                                {typeof item.type === 'string' && item.type.toLowerCase().includes('amount') && (
                                                    <> (<span className="mdi mdi-currency-rupee"></span>)</>
                                                )}
                                            </td>
                                            <td>{item?.location_name}</td>
                                            <td>{item.discount}</td>
                                            <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                            <td>{item.min_purchase_amount}</td>
                                            <td>{item.usage_limit}</td>
                                            <td>{item.used_count}</td>
                                            {/* <td>
                                                {moment(item.end_date).isValid() ? moment(item.end_date).format("DD-MM-YYYY") : ""}
                                            </td> */}
                                            <td>{item?.end_date}</td>
                                            <td>
                                                {moment(item.createdAt).format("DD-MM-YYYY")}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination justify-content-center mt-4">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </button>
                                    </li>

                                    {getPageNumbers().map((page, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                        >
                                            {page === "..." ? (
                                                <span className="page-link">...</span>
                                            ) : (
                                                <button className="page-link" onClick={() => handlePageChange(page)}>
                                                    {page}
                                                </button>
                                            )}
                                        </li>
                                    ))}
                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <section>
                <div className="modal" id="myModalViewDiscount">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Coupon Details</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                {/* End-Date	created-Date */}
                                <table className="table table-bordered border-secondary">
                                    <thead>
                                        <tr>
                                            <th>Code</th>
                                            <th>Type</th>
                                            <th>Discount</th>
                                        </tr>
                                        <tr>
                                            <td>{code}</td>
                                            <td>
                                                {type}
                                            </td>
                                            <td>{discount}</td>
                                        </tr>
                                        <tr><th>Purchase Amount</th>
                                            <th>Limit</th>
                                            <th>Count</th>
                                        </tr>
                                        <tr>
                                            <td>{purchaseAmount}</td>
                                            <td>{limit}</td>
                                            <td>{count}</td>
                                        </tr>
                                        <tr>
                                            <th>Center</th>
                                            <th>Start Date</th>
                                            <th>Expiry Date</th>
                                        </tr>
                                        <tr>
                                            <td>{center}</td>
                                            <td>{startDate}</td>
                                            <td>{endDate}</td>
                                        </tr>
                                        <tr>
                                            <th>Created Date</th>
                                            <th>Status</th>
                                        </tr>
                                        <tr>
                                            <td>{moment(createdAt).format("DD-MM-YYYY")}
                                            </td>
                                            <td>{status ? "Active" : "De-Activated"}</td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div className="modal-footer">
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="modal fade" id="myModal" data-bs-backdrop="static">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Update Coupon</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                {/* <div className="card-body"> */}
                                {/* <h4 className="card-title">Coupon</h4> */}
                                <div className="forms-sample">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>
                                                    Code <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Code"
                                                    value={code}
                                                    onChange={(e) => handleFieldChange(e, "code")}
                                                />
                                                {error?.code && (
                                                    <span className="text-danger" style={{ fontSize: "12px" }}>
                                                        {error.code}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <LocationList
                                                    selectedLocation={locationId}
                                                    label="Center"
                                                    isRequired={false}
                                                    disabled={false}
                                                    setSelectedLocation={(location) => {
                                                        setLocationId(location);
                                                        if (location.trim()) {
                                                            setError((prevErrors) => {
                                                                const updatedErrors = { ...prevErrors };
                                                                delete updatedErrors.locationId;
                                                                return updatedErrors;
                                                            });
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>
                                                    Type <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <select
                                                    className="form-select"
                                                    value={type}
                                                    onChange={(e) => handleFieldChange(e, "type")}
                                                >
                                                    <option value="">Select Type</option>
                                                    <option value="percentage">Percentage</option>
                                                    <option value="amount">Amount</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>
                                                    Discount <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="discount"
                                                    value={discount}
                                                    onChange={(e) => handleFieldChange(e, "discount")}
                                                />
                                                {error?.discount && (
                                                    <span className="text-danger" style={{ fontSize: "12px" }}>
                                                        {error.discount}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>
                                                    Purchase Amount <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Purchase Amount"
                                                    value={purchaseAmount}
                                                    onChange={(e) => handleFieldChange(e, "purchaseAmount")}
                                                />
                                                {error?.purchaseAmount && (
                                                    <span className="text-danger" style={{ fontSize: "12px" }}>
                                                        {error.purchaseAmount}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>
                                                    Limit <span style={{ color: "red" }}>*</span>

                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Limit"
                                                    value={limit}
                                                    onChange={(e) => handleFieldChange(e, "limit")}
                                                />
                                                {error?.limit && (
                                                    <span className="text-danger" style={{ fontSize: "12px" }}>
                                                        {error.limit}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>
                                                    Description <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Description"
                                                    value={description}
                                                    onChange={(e) => handleFieldChange(e, "description")}
                                                />
                                                {error?.description && (
                                                    <span className="text-danger" style={{ fontSize: "12px" }}>
                                                        {error.description}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        {/* <div className="col-md-4">
                                            <div className="form-group">
                                                <label>
                                                    Start Date <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    placeholder="start Date"
                                                    value={startDate}
                                                    onChange={(e) => handleFieldChange(e, "startDate")}
                                                />
                                                {error?.startDate && (
                                                    <span className="text-danger" style={{ fontSize: "12px" }}>
                                                        {error.startDate}
                                                    </span>
                                                )}
                                            </div>
                                        </div> */}
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>
                                                    Expiry Date <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    placeholder="End Date"
                                                    value={endDate}
                                                    onChange={(e) => handleFieldChange(e, "endDate")}
                                                />
                                                {error?.endDate && (
                                                    <span className="text-danger" style={{ fontSize: "12px" }}>
                                                        {error.endDate}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="mt-3">
                                        <button
                                            onClick={handleSubmit}
                                            type="submit"
                                            className="btn btn-primary"
                                        >
                                            Submit
                                        </button>
                                        <button onClick={handleCancel} className="btn btn-light ms-2">Cancel</button>
                                    </div> */}
                                    {/* </div> */}
                                </div>
                                <div className="d-flex justify-content-end gap-2 mt-4">
                                    <button className="btn btn-primary"
                                        type="button"
                                        onClick={handleUpdateData} >Update</button>

                                    <button onClick={handleCancel} type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default CouponList
